import React, { useState, useContext, useEffect } from "react";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import KeyboardArrowLeftIcon from "@material-ui/icons/KeyboardArrowLeft";
import ListItemText from "@material-ui/core/ListItemText";
import LockIcon from "@material-ui/icons/Lock";
import "./sidebar.css";
import { StoreContext } from "../../../store/Provider";
import { Link, useLocation } from "react-router-dom";
import { checkUser, checkAdmin } from "../utility/Utils";
import { basename } from "../../../config";

function Sidebar() {
  const url = useLocation();
  const [showUserList, setShowUserList] = useState(false);
  const [showResetPass, setShowResetPass] = useState(false);
  const context = useContext(StoreContext);

  const ShipmentPermisionCollection = {
    ShipmentDashBoard: false,
  };
  useEffect(() => {
    checkUser("UserDataLogin")
      .then((res) => {
        setShowUserList(res);
      })
      .catch((err) => console.log(err));
    checkAdmin("UserDataLogin")
      .then((res) => {
        setShowResetPass(res);
      })
      .catch((err) => console.log(err));
  }, []);

  return (
    <div
      className={
        context.closeSidebar
          ? "sidebarcomp closeSidebar"
          : "sidebarcomp openSidebar"
      }
    >
      <div className="mtsLogo py-2">
        <img src={`/${basename}/Assets/Images/mymtslogo.svg`} alt="mtsLogo" />
        {/* <KeyboardArrowLeftIcon className={context.closeSidebar ? 'pointer toggleSidebar flip' : 'pointer toggleSidebar'} onClick={() => context.setCloseSidebar(!context.closeSidebar)} /> */}
      </div>
      <div className="tabsName">
        <List>
          <Link to="/Shipments">
            <ListItem
              className={
                url.pathname === "/Shipments" || url.pathname === "/Login"
                  ? "selected"
                  : ""
              }
            >
              <ListItemIcon>
                {url.pathname === "/Shipments" ? (
                  <img
                    src={`/${basename}/Assets/Images/shpListw.svg`}
                    alt="shipmentList"
                  />
                ) : (
                  <img
                    src={`/${basename}/Assets/Images/shpListb.svg`}
                    alt="shipmentList"
                  />
                )}
              </ListItemIcon>
              {ShipmentPermisionCollection?.ShipmentDashBoard ? (
                <ListItemText>Shipment Listing</ListItemText>
              ) : null}
            </ListItem>
          </Link>
          <Link to="/Schedule">
            <ListItem
              className={
                url.pathname === "/Schedule" ||
                url.pathname === "/SearchResults"
                  ? "selected"
                  : ""
              }
            >
              <ListItemIcon>
                {url.pathname === "/Schedule" ||
                url.pathname === "/SearchResults" ? (
                  <img
                    src={`/${basename}/Assets/Images/schedulew.svg`}
                    alt="shipmentList"
                  />
                ) : (
                  <img
                    src={`/${basename}/Assets/Images/scheduleb.svg`}
                    alt="shipmentList"
                  />
                )}
              </ListItemIcon>
              <ListItemText>Schedule</ListItemText>
            </ListItem>
          </Link>

          <Link to="/Statements">
            <ListItem
              className={url.pathname === "/Statements" ? "selected" : ""}
            >
              <ListItemIcon>
                {url.pathname === "/Statements" ? (
                  <img
                    src={`/${basename}/Assets/Images/staccw.svg`}
                    alt="shipmentList"
                  />
                ) : (
                  <img
                    src={`/${basename}/Assets/Images/staccb.svg`}
                    alt="shipmentList"
                  />
                )}
              </ListItemIcon>
              <ListItemText>Statement of Account</ListItemText>
            </ListItem>
          </Link>
          <Link to="/Dashboard">
            <ListItem
              className={url.pathname === "/Dashboard" ? "selected" : ""}
            >
              <ListItemIcon>
                {url.pathname === "/Dashboard" ? (
                  <img
                    src={`/${basename}/Assets/Images/dashboardw.svg`}
                    alt="shipmentList"
                  />
                ) : (
                  <img
                    src={`/${basename}/Assets/Images/dashboardb.svg`}
                    alt="shipmentList"
                  />
                )}
              </ListItemIcon>
              <ListItemText>Dashboard</ListItemText>
            </ListItem>
          </Link>

          <Link to="/Blogs">
            <ListItem
              className={
                url.pathname === "/Blogs" || url.pathname === "/BlogsDetail"
                  ? "selected"
                  : ""
              }
            >
              <ListItemIcon>
                {url.pathname === "/Blogs" ||
                url.pathname === "/BlogsDetail" ? (
                  <img
                    src={`/${basename}/Assets/Images/blogsw.svg`}
                    alt="shipmentList"
                  />
                ) : (
                  <img
                    src={`/${basename}/Assets/Images/blogsb.svg`}
                    alt="shipmentList"
                  />
                )}
              </ListItemIcon>
              <ListItemText>Blogs</ListItemText>
            </ListItem>
          </Link>
          {showUserList ? (
            <Link to="/UserList">
              <ListItem
                className={url.pathname === "/UserList" ? "selected" : ""}
              >
                <ListItemIcon>
                  {url.pathname === "/UserList" ? (
                    <img
                      src={`/${basename}/Assets/Images/userSolidw.svg`}
                      alt="UserList"
                      style={{ height: "25px", width: "22px" }}
                    />
                  ) : (
                    <img
                      src={`/${basename}/Assets/Images/userSolidb.svg`}
                      alt="UserList"
                      style={{ height: "25px", width: "22px" }}
                    />
                  )}
                </ListItemIcon>
                <ListItemText>Users List</ListItemText>
              </ListItem>
            </Link>
          ) : null}
          {/* {
                        showResetPass ? <Link to="/ResetPasswordAdmin">

                            <ListItem className={url.pathname === "/ResetPasswordAdmin" ? "selected" : ""} >
                                <ListItemIcon>
                                    {url.pathname === "/ResetPasswordAdmin" ? <img src="/mtsomsmerge/Assets/Images/lockw.svg" alt="ResetPasswordAdmin" style={{ height: '25px', width: '22px' }} /> : <img src="/mtsomsmerge/Assets/Images/lockb.svg" alt="ResetPasswordAdmin" style={{ height: '25px', width: '22px' }} />}
                                </ListItemIcon>
                                <ListItemText>Reset Password</ListItemText>
                            </ListItem>
                        </Link> : null
                    } */}
        </List>
      </div>
      <div className="dummyimage">
        <img src={`/${basename}/Assets/Images/cardbox.svg`} alt="card box" />
      </div>
    </div>
  );
}

export default Sidebar;
